import { EChartsOption } from 'echarts';
import ReactECharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next';
import { formatNumber } from 'utils/formatHelper';

export interface ChartDataType {
  name: string;
  total?: number[];
  stack?: string;
  fontSize?: number;
}

export interface BarChartProps {
  data: ChartDataType[];
  valueName?: string[] | string;
  label?: string[];
  color?: string[];
  className?: string;
  rotateLabel?: boolean;
  title?: string;
  subTitle?: string;
  yAxisName?: boolean;

  totalData?: number[]
}

function CustomBar({ yAxisName = true, ...props }: BarChartProps) {
  var option: EChartsOption;

  const screenWidth = window.screen.width;


  // const temptData = [...props.data]
  // temptData.push(
  //   {
  //     name: 'Hoạt động chưa hoàn thành',
  //     stack: 'total',
  //     fontSize: 13,
  //     total: props.totalData,
  //   },
  // )

  //=====================================CHUYỂN NGÔN NGỮ=====================================//
  const { t } = useTranslation();

  option = {
    title: {
      text: props.title,
      subtext: props.subTitle,
      right: 'center',
      textStyle: {
        fontFamily: 'roboto',
      },
      itemGap: 0,
      subtextStyle: {
        fontFamily: 'roboto',
        fontSize: '14px',
        fontWeight: 'bold',
        lineHeight: 25,

        color: props.color ? props.color[0] : '#5AC29C',
      },
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        fontFamily: 'inherit',
        fontSize: 12,
      },
      borderRadius: 3,
      borderWidth: 0,
      shadowOffsetX: 0,
      shadowOffsetY: 1,
      shadowBlur: 3,
      shadowColor: 'rgba(0, 0, 0, 0.25)',
      axisPointer: {
        type: 'cross',
        label: {
          backgroundColor: '#C5DFEB',
          fontFamily: 'roboto',
          fontSize: 10,
          fontWeight: 400,
        },
      },
      className:
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!rounded-[1px] ' +
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!w-[19px] ' +
        '[&>div>:nth-child(1)>:nth-child(2)>div>:nth-child(1)>:nth-child(1)]:!h-[12px] ' +
        '[&>div>:nth-child(1)>:nth-child(1)]:!font-semibold ' +
        '[&>div>:nth-child(1)>:nth-child(1)]:!text-textColor',
    },
    color: props.color ? props.color : ['#5AC29C', '#5281BB'],
    legend: {
      orient: 'vertical',
      left: "left",
      itemGap: 5,
      textStyle: {
        fontFamily: 'roboto',
        fontSize: 10,
        color: '#77838F',
      },
    },
    toolbox: {
      show: false,
      feature: {
        dataView: { readOnly: false },
        restore: {},
        saveAsImage: {},
      },
    },
    grid: {
      left: '3%',
      right: '3%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        boundaryGap: true,
        axisLabel: {
          interval: 'auto',
          hideOverlap: true,
          fontSize: 12,
          fontFamily: 'roboto',
          fontWeight: 400,
          color: '#77838F',
          lineHeight: 12,
          // rotate: (
          //   screenWidth >= 768 && props.rotateLabel ? 25 :
          //     screenWidth >= 360 && props.rotateLabel ? 60 :
          //       screenWidth >= 768 ? 0 :
          //         screenWidth >= 360 ? 50 : 0),
          rotate: 25,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        data: props.label,
      },
    ],
    yAxis: [
      {
        minInterval: 1,
        name: yAxisName ? t('dashboard.chart.value') : undefined,
        type: 'value',
        axisLabel: { fontFamily: 'roboto', fontSize: 12, fontWeight: 400, lineHeight: 20, color: '#77838F' },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        nameTextStyle: {
          fontFamily: 'roboto',
          fontSize: 12,
          fontWeight: 400,
          lineHeight: 20,
          color: '#000',
        },

      },
    ],

    series: props.data.map((i, index) => {
      return {
        name: i.name,
        type: 'bar',
        data: i.total,
        barMaxWidth: 200,
        // color: index === 2 ? 'transparent' : '',
        // tooltip: {
        //   valueFormatter: function (value) {
        //     return value + ' (hoạt động)';
        //   }
        // },
        // tooltip: {
        //   show: index === 2 ? false : true
        // },


        label: {
          show: true,
          position: 'top',
          fontFamily: 'roboto',
          fontSize: i.fontSize ? i.fontSize : 10,
          fontWeight: 'bold',
          color: 'black',

          formatter: function (value) {
            const valueName = props.valueName ? ' KH' : ' ';
            if (value.data) {
              return formatNumber(Number(value.data), 0) + valueName;
            } else {
              return '';

            }
          },
        },
      };
    }),
  };

  return <ReactECharts option={option} className={props.className} />;
}

export default CustomBar;
